<template>
  <Head title="Pathways" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <pathways 
            :tab_name="tab_name" 
            :client="client" 
            :datasets="datasets" 
            :datablends="datablends" 
            :connections="connections" 
            :census_connections="census_connections" 
            :segments="segments" 
            :segment_selected_passed="segment_selected"   
            :pathway_selected_passed="pathway_selected"
          ></pathways>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  client: Object,
  tab_name: String,
  connections: Array,
  datasets: Array,
  datablends: Array,
  census_connections: Array,
  segments: Array,
  segment_selected: {
    type: Object,
    default: null
  },
  pathway_selected: {
    type: Object,
    default: null
  }
});
</script>

